// extracted by mini-css-extract-plugin
export default {"touch_component":"PreviewImageFileComponent_touch_component__TdRQ1"};